// import { useNavigate } from "react-router";
// import { cn } from "../../utils/cn";
// import { Column, FleetrifyCustomTable } from "../CustomTable/customTable";

// interface OrderTableRow {
//   id: number;
//   orderId: string;
//   customer: string;
//   serviceType: string;
//   pickUpLocation: string;
//   deliveryLocation: string;
//   status: string;
//   date: string;
// }

// export interface AnimatedTableProps {
//   data: OrderTableRow[];
//   columns: Column[];
//   checkbox?: boolean;
//   initialPage?: number;
//   initialPageSize?: number;
//   className?: string;
//   view?: boolean;
// }

// const OrdersTable = ({
//   renderLeftContent,
//   tableData,
//   currentPage,
//   lastPage,
//   pageSize,
//   setCurrentPage,
//   isLoading,
// }: {
//   renderLeftContent: React.ReactNode;
//   tableData: OrderTableRow[];
//   currentPage?: number;
//   lastPage?: number;
//   pageSize?: number;
//   setCurrentPage?: (page: number) => void;
//   isLoading?: boolean;
// }) => {
//   // const tableData: OrderTableRow[] = [
//   //   {
//   //     id: 53767,
//   //     customer: "Dom Enterprise",
//   //     serviceType: "Local dispatch",
//   //     pickUpLocation: "Lagos",
//   //     deliveryLocation: "Lagos",
//   //     status: "Completed",
//   //     date: "March 15, 2025",
//   //   },
//   //   {
//   //     id: 53767,
//   //     customer: "Peniel Travels",
//   //     serviceType: "Delivery",
//   //     pickUpLocation: "Kumasi",
//   //     deliveryLocation: "Kumasi",
//   //     status: "Pending",
//   //     date: "March 15, 2025",
//   //   },
//   //   {
//   //     id: 53767,
//   //     customer: "Charly & Sons",
//   //     serviceType: "Relocation",
//   //     pickUpLocation: "Abuja",
//   //     deliveryLocation: "Abuja",
//   //     status: "In-Transit",
//   //     date: "March 15, 2025",
//   //   },
//   //   {
//   //     id: 53767,
//   //     customer: "Chioma Eze",
//   //     serviceType: "Transportation",
//   //     pickUpLocation: "Ibadan",
//   //     deliveryLocation: "Ibadan",
//   //     status: "Canceled",
//   //     date: "March 15, 2025",
//   //   },
//   //   {
//   //     id: 53767,
//   //     customer: "Peniel Travels",
//   //     serviceType: "Local dispatch",
//   //     pickUpLocation: "Lome",
//   //     deliveryLocation: "Nigeria",
//   //     status: "Completed",
//   //     date: "March 15, 2025",
//   //   },
//   //   {
//   //     id: 53767,
//   //     customer: "Charles Angels",
//   //     serviceType: "Delivery",
//   //     pickUpLocation: "Onitsha",
//   //     deliveryLocation: "Owerri",
//   //     status: "In-Transit",
//   //     date: "March 15, 2025",
//   //   },
//   //   {
//   //     id: 53767,
//   //     customer: "Odogwu Paranran",
//   //     serviceType: "Delivery",
//   //     pickUpLocation: "Onitsha",
//   //     deliveryLocation: "Kogi",
//   //     status: "Canceled",
//   //     date: "March 15, 2025",
//   //   },
//   //   {
//   //     id: 53767,
//   //     customer: "Odogwu Paranran",
//   //     serviceType: "Relocation",
//   //     pickUpLocation: "Ondo",
//   //     deliveryLocation: "Lokoja",
//   //     status: "Completed",
//   //     date: "March 15, 2025",
//   //   },
//   //   {
//   //     id: 53767,
//   //     customer: "NSPPD Movements",
//   //     serviceType: "Delivery",
//   //     pickUpLocation: "Onitsha",
//   //     deliveryLocation: "Gboko",
//   //     status: "Completed",
//   //     date: "March 15, 2025",
//   //   },
//   //   {
//   //     id: 53767,
//   //     customer: "Odogwu Paranran",
//   //     serviceType: "Relocation",
//   //     pickUpLocation: "Ondo",
//   //     deliveryLocation: "Awka",
//   //     status: "Completed",
//   //     date: "March 15, 2025",
//   //   },
//   // ];

//   // Updated columns
//   const columns: Column[] = [
//     { label: "#OrderID", key: "orderId", sortable: true },
//     { label: "Customer", key: "customer", sortable: true },
//     { label: "Service type", key: "serviceType", sortable: true },
//     { label: "Pick-up location", key: "pickUpLocation", sortable: true },
//     { label: "Delivery location", key: "deliveryLocation", sortable: true },
//     {
//       label: "Status",
//       key: "status",
//       render: (value) => {
//         const status = value || "pending";
//         return (
//           <span
//             className={cn(
//               "px-2 py-1 rounded",
//               status.toLowerCase() === "delivered"
//                 ? "bg-green-100 text-green-800"
//                 : status.toLowerCase() === "pending"
//                   ? "bg-yellow-100 text-yellow-800"
//                   : status.toLowerCase() === "in progress"
//                     ? "bg-blue-100 text-blue-800"
//                     : status.toLowerCase() === "accepted"
//                       ? "bg-indigo-100 text-indigo-800"
//                       : status.toLowerCase() === "out for delivery"
//                         ? "bg-purple-100 text-purple-800"
//                         : status.toLowerCase() === "picked up"
//                           ? "bg-teal-100 text-teal-800"
//                           : status.toLowerCase() === "in transit"
//                             ? "bg-blue-100 text-blue-800"
//                               : "bg-red-100 text-red-800"
//             )}
//           >
//             {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
//           </span>
//         );
//       },
//     },
//     { label: "Date", key: "date", sortable: true },
//   ];

//   const navigate = useNavigate()
//   return (
//     <div>
//       <FleetrifyCustomTable
//         onRowClick={(row) => navigate(`/orders/view-order/${row.id}`)}
//         tableTitle="Order Data Table"
//         renderLeftContent={renderLeftContent}
//         data={tableData}
//         columns={columns}
//         checkbox={true}
//         currentPage={currentPage}
//         lastPage={lastPage}
//         pageSize={pageSize}
//         setCurrentPage={setCurrentPage}
//         isLoading={isLoading}
//       />
//     </div>
//   );
// };

// export default OrdersTable;



import { useNavigate } from "react-router";
import { cn } from "../../utils/cn";
import { Column, FleetrifyCustomTable } from "../CustomTable/customTable";
import { PaymentBadges } from "../PaymentBadges";
import { NegotiationRequestBadge } from "../NegotiationRequest";

interface OrderTableRow {
  id: string;
  orderId: string;
  customer: string;
  serviceType: string;
  pickUpLocation: string;
  deliveryLocation: string;
  price: string;
  driver: string | null;
  status: string;
  date: string;
  paymentStatus?: string | null;
  paymentPreference?: string | null;
  paymentMethod?: string | null;
  cashCollected?: boolean | null;
  customerConfirmedCashAt?: string | null;
  // Customer tapped "Negotiate" on this order.
  negotiationRequested?: boolean;
}

export interface AnimatedTableProps {
  data: OrderTableRow[];
  columns: Column[];
  checkbox?: boolean;
  initialPage?: number;
  initialPageSize?: number;
  className?: string;
  view?: boolean;
}

const OrdersTable = ({
  renderLeftContent,
  tableData,
  currentPage,
  lastPage,
  pageSize,
  total,
  setCurrentPage,
  isLoading,
}: {
  renderLeftContent: React.ReactNode;
  tableData: OrderTableRow[];
  currentPage?: number;
  lastPage?: number;
  pageSize?: number;
  total?: number;
  setCurrentPage?: (page: number) => void;
  isLoading?: boolean;
}) => {

  const formatPrice = (price: string) => {
    const num = parseFloat(price);
    if (isNaN(num)) return "—";
    return num.toLocaleString("en-NG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatStatus = (status: string) => {
    return status
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const getStatusClasses = (status: string) => {
    const s = status.toLowerCase().replace(/_/g, " ");
    if (s === "delivered" || s === "completed")
      return "bg-green-100 text-green-800";
    if (s === "pending")
      return "bg-yellow-100 text-yellow-800";
    if (s === "in progress")
      return "bg-blue-100 text-blue-800";
    if (s === "counter sent")
      return "bg-amber-100 text-amber-800";
    if (s === "customer countered")
      return "bg-fuchsia-100 text-fuchsia-800";
    if (s === "accepted")
      return "bg-indigo-100 text-indigo-800";
    if (s === "company accepted")
      return "bg-teal-100 text-teal-800";
    if (s === "driver assigned")
      return "bg-purple-100 text-purple-800";
    if (s === "out for delivery")
      return "bg-purple-100 text-purple-800";
    if (s === "picked up" || s === "in transit")
      return "bg-blue-100 text-blue-800";
    if (s === "cancelled" || s === "rejected" || s === "driver rejected")
      return "bg-red-100 text-red-800";
    return "bg-gray-100 text-gray-700";
  };

  const columns: Column[] = [
    {
      label: "#OrderID",
      key: "orderId",
      sortable: true,
    },
    {
      label: "Customer",
      key: "customer",
      sortable: true,
    },
    {
      label: "Service Type",
      key: "serviceType",
      sortable: true,
    },
    {
      label: "Pick-up Location",
      key: "pickUpLocation",
      sortable: true,
    },
    {
      label: "Delivery Location",
      key: "deliveryLocation",
      sortable: true,
    },
    {
      label: "Price",
      key: "price",
      sortable: true,
      render: (value: any) => (
        <span className="font-medium text-[#00032A]">
          ₦{formatPrice(value)}
        </span>
      ),
    },
    {
      label: "Driver",
      key: "driver",
      sortable: false,
      render: (value: any) =>
        value ? (
          <span className="text-[#00032A] font-medium">{value}</span>
        ) : (
          <span className="text-xs text-gray-400 italic">Unassigned</span>
        ),
    },
    {
      label: "Status",
      key: "status",
      render: (value: any, row: OrderTableRow) => {
        const status = value || "pending";
        return (
          <div className="flex flex-col items-start gap-1">
            <span
              className={cn(
                "px-2 py-1 rounded text-xs font-medium whitespace-nowrap",
                getStatusClasses(status)
              )}
            >
              {formatStatus(status)}
            </span>
            {row?.negotiationRequested && <NegotiationRequestBadge />}
          </div>
        );
      },
    },
    {
      label: "Payment",
      key: "paymentStatus",
      sortable: false,
      render: (_value: any, row: OrderTableRow) => (
        <PaymentBadges
          paymentStatus={row.paymentStatus}
          paymentPreference={row.paymentPreference}
          paymentMethod={row.paymentMethod}
          cashCollected={row.cashCollected}
          customerConfirmedCashAt={row.customerConfirmedCashAt}
        />
      ),
    },
    {
      label: "Date",
      key: "date",
      sortable: true,
    },
  ];

  const navigate = useNavigate();

  return (
    <div>
      <FleetrifyCustomTable
        onRowClick={(row) => navigate(`/orders/view-order/${row.id}`)}
        tableTitle="Order Data Table"
        renderLeftContent={renderLeftContent}
        data={tableData}
        columns={columns}
        checkbox={true}
        currentPage={currentPage}
        lastPage={lastPage}
        pageSize={pageSize}
        total={total}
        setCurrentPage={setCurrentPage}
        isLoading={isLoading}
      />
    </div>
  );
};

export default OrdersTable;